export const simplyBookApp = 'gifture';
export const simplyBookPublicKey = '0a20f3546afc384b2a8f1f66a6aad31843674891524aaec575424b2cba7c5ea0';
export const publicMode = (process.env.NODE_ENV === 'production');


// WEBPACK FOOTER //
// ./src/config/config.js